/**
 * Traduções de produtos (Recarga de Diamantes + Assinatura VIP)
 * Inclui: Processo de pagamento, seleção de produtos, etc.
 */
export default {
  // Traduções comuns
  failedToLoadProducts: 'Falha ao carregar produtos',
  selectPaymentMethod: 'Selecione o Método de Pagamento',
  purchase: 'Comprar',
  processing: 'Processando...',
  pleaseSelectPackage: 'Por favor, selecione um pacote',
  pleaseSelectPayment: 'Por favor, selecione um método de pagamento',
  paymentFailed: 'Falha na requisição de pagamento, tente novamente',
  invalidPaymentResponse: 'Resposta de pagamento inválida',
  buyDiamonds: 'Comprar Diamantes',
  myBalance: 'Meu Saldo: ',
  // 限购次数文案
  onlyLimitTimes: {
    '1': 'Apenas uma vez',
    '2': 'Apenas duas vezes',
    '3': 'Apenas três vezes',
    '4': 'Apenas quatro vezes',
    '5': 'Apenas cinco vezes',
    '6': 'Apenas seis vezes',
    '7': 'Apenas sete vezes',
    '8': 'Apenas oito vezes',
    '9': 'Apenas nove vezes',
    'other': 'Apenas {count} vezes'
  },
  paymentWindowOpenFailed: {
    title: 'Falha ao abrir janela de pagamento',
    message: 'O navegador pode ter bloqueado o pop-up, clique em "Continuar" para tentar novamente',
    continue: 'Continuar',
  },

  // Específico de assinatura VIP
  vip: {
    validUntil: 'VIP válido até {date}',
    notVipYet: 'Você ainda não é VIP',
    vipMember: 'Você é um membro VIP',
    onlyOneTime: 'Limitado',
    benefitsDescription:
      'A partir de {date}, seus benefícios diários são: chat gratuito, {oldDiamondCount} diamantes. Após a renovação, os benefícios diários serão alterados para {newDiamondCount} diamantes/dia.',
    onlyOneTimeBenefitsTitle: 'Benefícios únicos',
  },
}
